module.exports = __webpack_public_path__ + "media/flat/discover-28236ccf.svg";